import { render, staticRenderFns } from "./FeedingProgramCategoryForm.vue?vue&type=template&id=4f648872&lang=pug"
import script from "./FeedingProgramCategoryForm.vue?vue&type=script&lang=js"
export * from "./FeedingProgramCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VRow,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f648872')) {
      api.createRecord('4f648872', component.options)
    } else {
      api.reload('4f648872', component.options)
    }
    module.hot.accept("./FeedingProgramCategoryForm.vue?vue&type=template&id=4f648872&lang=pug", function () {
      api.rerender('4f648872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/FeedingProgramCategoryForm.vue"
export default component.exports